<template>
  <div class="container-fluid my-5">
    <loading
      :active.sync="loading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="false"
      :height="25"
      :width="25"
    ></loading>

    <div class="section my-4" v-if="loading == false">
      <div class="row">
        <figure class="col-md-4">
          <img
            class="img-fluid"
            :src="product.image ? product.image.url : defaultImage"
          />
        </figure>
        <div class="col-md-8">
          <div class="card-content__title">
            <h1 class="title is-4">
              {{ product.name }}
              <button
                class="btn btn-small btn-success"
                :title="removeFromFavouriteLabel"
                v-show="product.isFavourite"
                @click.stop="removeFromFavourite(product.id)"
              >
                <span class="icon is-small">
                  <i class="fas fa-heart"></i>
                </span>
              </button>
              <button
                class="btn btn-small btn-success"
                :title="addToFavouriteLabel"
                v-show="!product.isFavourite"
                @click.stop="saveToFavorite(product.id)"
              >
                <span class="icon is-small">
                  <i class="far fa-heart"></i>
                </span>
              </button>
            </h1>
          </div>
          <div class="card-content__text">
            <p>{{ product.description }}</p>
          </div>
          <div class="card-content__ratings" v-if="product.rating === 1">
            <i class="fa fa-star"></i>
          </div>
          <div class="card-content__ratings" v-else-if="product.rating === 2">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <div class="card-content__ratings" v-else-if="product.rating === 3">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <div class="card-content__ratings" v-else-if="product.rating === 4">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <div class="card-content__ratings" v-else-if="product.rating === 5">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <div class="card-content__reviews">
            <div class="is-pulled-left">
              <p>
                <span>{{
                  product.reviews > 0 ? `${product.reviews} نظر` : "بدون نظر"
                }}</span>
              </p>
            </div>
            <div class="select is-rounded is-small is-pulled-right">
              <!-- <select @change="onSelectQuantity(product)" v-model="product.quantity">
              <option v-for="(quantity, index) in 10" :value="quantity" :key="index">{{ quantity }}</option>
              </select>-->

              <!-- <b-form-select
                @change="onSelectQuantity(product)"
                v-model="product.quantity"
                :options="options"
                class="mt-3"
              ></b-form-select> -->
            </div>
          </div>
          <div class="card-content__price is-pulled-left my-2">
            <span class="title is-3">
              <strong>{{ formatNumber(product.price) }}</strong>
            </span>
          </div>
          <div class="card-content__btn is-pulled-right">
            
            <count-ctrl :product="product" :cartItem="findInCart(product.id)" />

            <!-- <button
              class="btn btn-primary"
              v-if="!isAddedToCart(product.id)"
              @click.stop="addToCart(product)"
            >
              {{ addToCartLabel }}
            </button>
            <button
              class="btn btn-danger"
              v-else
              @click.stop="removeFromCart(product.id)"
            >
              {{ removeFromCartLabel }}
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CountCtrl from "@/components/CountCtrl";

export default {
  name: "product-detail-component",

  components: {
    "count-ctrl": CountCtrl,
  },

  metaInfo() {
    const title = this.product ? this.product.name : null;
    return {
      title: title,
      //meta: [{ name: "description", content: "My page meta description" }],
    };
  },

  data() {
    return {
      loading: true,

      addToCartLabel: "افزودن به سبد",
      removeFromCartLabel: "حذف از سبد",
      addToFavouriteLabel: "افزودن به علاقه مندی",
      removeFromFavouriteLabel: "حدف از علاقه مندی",
      // product: {},
      defaultImage: "https://bulma.io/images/placeholders/480x480.png",

      selected: 1,
      options: [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
        { value: 5, text: "5" },
        { value: 6, text: "6" },
        { value: 7, text: "7" },
        { value: 8, text: "8" },
        { value: 9, text: "9" },
        { value: 10, text: "10" },
      ],
    };
  },

  mounted() {
    // this.product = this.$store.getters.getProductById(this.$route.params.id);
    this.fetchProduct();
  },

  computed: {
    isAddedBtn() {
      return this.product.isAddedBtn;
    },
    ...mapGetters({
      cartItems: "cartItems",
      product: "product",
    }),
  },

  methods: {
    fetchProduct() {
      this.loading = true;
      this.$store
        .dispatch("fetchProduct", this.$route.params.id)
        .then((product) => {
          this.loading = false;
        })
        .catch(() => {});
    },

    addToCart(product) {
      this.$store.dispatch("addToCart", product);
    },
    removeFromCart(id) {
      this.$store.dispatch("removeFromCart", id);
    },
    onSelectQuantity(product) {
      this.$store.dispatch("updateItem", product);
    },
    saveToFavorite(id) {
      let isUserLogged = this.$store.state.userInfo.isLoggedIn;

      if (isUserLogged) {
        this.$store.commit("addToFavourite", id);
      } else {
        this.$store.commit("showLoginModal", true);
      }
    },
    removeFromFavourite(id) {
      this.$store.commit("removeFromFavourite", id);
    },

    isAddedToCart(id) {
      const exists = this.cartItems.find((item) => item.product_id === id);
      if (exists) {
        return true;
      }
      return false;
    },

    findInCart(id) {
      return this.cartItems.find((item) => item.product_id === id);
    },

    onCancel() {},
  },
};
</script>

<style lang="scss" scoped>
.card-content {
  padding: 15px 10px 15px 0;

  &__text {
    margin: 15px 0;
  }
  &__reviews {
    display: inline-block;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>

